import { SET_FNA_VALUE } from '../actions'

export const setFnaMarketConductValue = (path, value) => ({
  type: SET_FNA_VALUE,
  payload: {
    path: 'marketConduct.' + path,
    value: value,
  },
})

export const setFnaMarketConductReasonOthers = (value) => setFnaMarketConductValue('reasonOthers', value)

export const setMarketConductQuestion = (questionKey, value) =>
  setFnaMarketConductValue(`questions.${questionKey}`, value)

export const setReasonForNeverSplittingPremiumFromExpense = (value) =>
  setFnaMarketConductValue('questions.reasonSplittingPremiumFromExpense', value)

export const setFnaMarketConductThirdPersonFullName = (value) => setFnaMarketConductValue('thirdPerson.fullName', value)

export const setFnaMarketConductThirdPersonRelationship = (value) =>
  setFnaMarketConductValue('thirdPerson.relationship', value)

export const setFnaMarketConductThirdPersonPhoneNumber = (value) =>
  setFnaMarketConductValue('thirdPerson.phoneNumber', value)

export const setFnaMarketConductThirdPersonTitle = (value) => setFnaMarketConductValue('thirdPerson.title.value', value)

export const setFnaMarketConductThirdPersonTitleText = (value) =>
  setFnaMarketConductValue('thirdPerson.title.text', value)

export const setFnaMarketConductThirdPersonFirstName = (value) =>
  setFnaMarketConductValue('thirdPerson.firstName', value)

export const setFnaMarketConductThirdPersonLastName = (value) => setFnaMarketConductValue('thirdPerson.lastName', value)

export const SET_MARKET_CONDUCT_REASON_VALUE = 'SET_MARKET_CONDUCT_REASON_VALUE'

export const setMarketConductReasonValue = (value) => {
  return {
    type: SET_MARKET_CONDUCT_REASON_VALUE,
    payload: {
      value: value,
    },
  }
}

export const SET_CURRENT_MARKET_CONDUCT_FORM = 'SET_CURRENT_MARKET_CONDUCT_FORM'

export const setCurrentMarketConductForm = (value) => {
  return {
    type: SET_CURRENT_MARKET_CONDUCT_FORM,
    payload: {
      value,
    },
  }
}

export const CLEAR_MARKET_CONDUCT_FORM = 'CLEAR_MARKET_CONDUCT_FORM'

export const clearMarketConductForm = () => ({
  type: CLEAR_MARKET_CONDUCT_FORM,
})

export const CLEAR_MARKET_CONDUCT_REASON_OTHERS = 'CLEAR_MARKET_CONDUCT_REASON_OTHERS'

export const clearMarketConductReasonOthers = () => {
  return {
    type: CLEAR_MARKET_CONDUCT_REASON_OTHERS,
  }
}

export const CLEAR_THIRD_PERSON = 'CLEAR_THIRD_PERSON'

export const clearThirdPerson = () => {
  return {
    type: CLEAR_THIRD_PERSON,
  }
}
